import address from "./address";
import cart from "./cart";
import location from "./location";
import order from "./order";
import offer from "./offer";

const FRAGMENTS = { address, cart, order, location, offer };

export default FRAGMENTS;
